<div class="view-header" [class.no-banner]="embedService.embed">
  @if (
    initiative ||
    ((job$ | async) && ((job$ | async).open || missingData || manualApplication) && !errorGettingMissingData)
    ) {
    <div
      class="view-header-content"
      >
      <div class="links">
        <div class="left">
          <a
            class="icon"
          [routerLink]="
            initiative
              ? ['/companies', route.snapshot.params['companyId']]
              : ['/companies', (job$ | async)?.companyID, 'jobs', (job$ | async)?.id]
          "
            >
            <fa-icon [icon]="fontawesomeService.regular.chevronLeft"></fa-icon>
          </a>
          <p class="d-none d-sm-block">{{ 'jobboard.views.apply.button-back' | transloco }}</p>
          <p class="d-block d-sm-none">{{ 'jobboard.views.job.back-button-sm' | transloco }}</p>
        </div>
      </div>
      <h1>{{ initiative ? ('jobboard.views.apply.unsolicited' | transloco) : (job$ | async)?.jobTitle }}</h1>
      @if (!initiative) {
        <div class="content">
          @if (!refService.refCompany && !manualApplication) {
            <ul>
              <li>{{ (job$ | async)?.companyTitle }}</li>
              @if ((job$ | async)?.website) {
                <li>
                  <a [href]="(job$ | async)?.website" target="_blank">
                    Website <fa-icon [icon]="fontawesomeService.regular.externalLink"></fa-icon>
                  </a>
                </li>
              }
            </ul>
          }
          <div class="description">
            <app-header-tags
              [startDate]="(job$ | async)?.startDate"
              [employmentType]="(job$ | async)?.employmentType"
              [workingTime]="(job$ | async)?.workingTime"
              [locations]="(job$ | async)?.workLocations"
              [workingModel]="(job$ | async)?.workingModel"
              [searchRegionAddress]="(job$ | async)?.searchRegionAddress"
              [showSalaryRangeOnJobboard]="(job$ | async)?.showSalaryRangeOnJobboard ?? false"
              [salaryCurrency]="(job$ | async)?.currency"
              [salaryMin]="(job$ | async)?.salaryMin"
              [salaryMax]="(job$ | async)?.salaryMax"
              [fallbackSalary]="(job$ | async)?.salary"
              [salaryInterval]="(job$ | async)?.salaryInterval"
            ></app-header-tags>
          </div>
        </div>
      }
    </div>
  }
</div>
@if ( initiative || (((job$ | async)?.open || missingData && !errorGettingMissingData || manualApplication))) { @if
  (!success) {
  <div class="view-content">
    <h1 class="mb-5">{{ initiative ? ('jobboard.views.apply.unsolicited' | transloco) : (job$ | async)?.jobTitle }}</h1>
    <form [formGroup]="applyForm">
      <ct-lib-inline-info [infoIconAccentColor]="colorService.accent">
        <p [innerHTML]="'jobboard.views.apply.inline-info' | transloco"></p>
      </ct-lib-inline-info>
      @if (loggedIn()) {
        <ct-lib-info-banner type="info">
          <p>{{ 'jobboard.views.apply.prefill-info' | transloco }}</p>
        </ct-lib-info-banner>
      }
      @if (missingData) {
        <div class="apply mb-4">
          <button
            type="button"
            class="ct-btn ct-btn-themed-solid apply-btn"
            (click)="openFollowUpWithProfile()"
          >
            {{ 'jobboard.platform.apply-with-profile.follow-up-cta' | transloco }}
          </button>
        </div>
      }
      @if (initiative) {
        <div class="view-section">
          <h4>{{ 'jobboard.views.apply.sections.details.title' | transloco }}</h4>
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              [formControl]="jobTitle"
              [placeholder]="('jobboard.views.apply.sections.details.form.job-title.placeholder' | transloco) + ' *'"
              [autocomplete]="'off'"
              maxlength="200"
              id="jobTitle"
              />
            <label for="jobTitle">{{
              ('jobboard.views.apply.sections.details.form.job-title.placeholder' | transloco) +
              '
              *'
            }}</label>
            <div class="validation">
              <p>{{ 'ct-library.validation.required' | transloco }}</p>
            </div>
          </div>
        </div>
      }
      @if (!missingData || (missingData && missingDataFieldsGeneral())) {
        <div class="view-section">
          <h4>{{ 'jobboard.views.apply.sections.general.title' | transloco }}</h4>
          <div class="row">
            @if (!missingData || missingTitle) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.col-md-12]="(missingData && !missingAcademicTitle) || (!normalApplication && !manualApplication)"
                [class.invalid]="title.invalid && applyFormSubmitAttempt"
                >
                <ng-select
                  [formControl]="title"
                  [searchable]="false"
                  class="form-control"
                  id="title"
                  [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  >
                  @for (
                    salutationConstant of constantsService.getLabelValueArray(constantsService.salutationConstants)
                    ; track
                    salutationConstant) {
                    <ng-option
                      [value]="salutationConstant.value"
                      >
                      {{ salutationConstant.label | transloco }}
                    </ng-option>
                  }
                </ng-select>
                <label for="title">{{
                  ('jobboard.views.apply.sections.general.form.inputs.title' | transloco) +
                  '
                  *'
                }}</label>
                <div class="validation">
                  <p>{{ 'ct-library.validation.required' | transloco }}</p>
                </div>
              </div>
            }
            @if (!missingData) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.col-md-12]="missingData && !missingTitle"
                [class.invalid]="academicTitle.invalid && applyFormSubmitAttempt"
                >
                <ng-select
                  [searchable]="false"
                  [formControl]="academicTitle"
                  class="form-control"
                  id="academicTitle"
                  [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  >
                  @for (
                    academicTitleConstant of constantsService.getLabelValueArray(
                    constantsService.academicTitleConstants
                    )
                    ; track
                    academicTitleConstant) {
                    <ng-option
                      [value]="academicTitleConstant.value"
                      >
                      {{ academicTitleConstant.label | transloco }}
                    </ng-option>
                  }
                </ng-select>
                <label for="academicTitle">{{
                  'jobboard.views.apply.sections.general.form.inputs.academic-title' | transloco
                }}</label>
                <div class="validation">
                  <p>{{ 'ct-library.validation.required' | transloco }}</p>
                </div>
              </div>
            }
            @if (!missingData || missingName) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="firstName.invalid && applyFormSubmitAttempt"
                >
                <input
                  type="text"
                  class="form-control"
                  [formControl]="firstName"
                  id="firstName"
                  [placeholder]="('jobboard.views.apply.sections.general.form.inputs.first-name' | transloco) + ' *'"
                  [autocomplete]="'off'"
                  maxlength="30"
                  />
                <label for="firstName">{{
                  ('jobboard.views.apply.sections.general.form.inputs.first-name' | transloco) +
                  '
                  *'
                }}</label>
                <div class="validation">
                  @if (firstName.hasError('required')) {
                    <p>{{ 'ct-library.validation.required' | transloco }}</p>
                  }
                  @if (firstName.hasError('pattern') && !firstName.hasError('required')) {
                    <p>
                      {{ 'ct-library.validation.pattern' | transloco }}
                    </p>
                  }
                </div>
              </div>
            }
            @if (!missingData || missingName) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="lastName.invalid && applyFormSubmitAttempt"
                >
                <input
                  type="text"
                  class="form-control"
                  [formControl]="lastName"
                  id="lastName"
                  [placeholder]="('jobboard.views.apply.sections.general.form.inputs.last-name' | transloco) + ' *'"
                  [autocomplete]="'off'"
                  maxlength="30"
                  id="lastName"
                  />
                <label for="lastName">{{
                  ('jobboard.views.apply.sections.general.form.inputs.last-name' | transloco) +
                  '
                  *'
                }}</label>
                <div class="validation">
                  @if (lastName.hasError('required')) {
                    <p>{{ 'ct-library.validation.required' | transloco }}</p>
                  }
                  @if (lastName.hasError('pattern') && !lastName.hasError('required')) {
                    <p>
                      {{ 'ct-library.validation.pattern' | transloco }}
                    </p>
                  }
                </div>
              </div>
            }
            @if (!missingData) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="email.invalid && applyFormSubmitAttempt"
                >
                <input
                  type="email"
                  class="form-control"
                  [formControl]="email"
                  [placeholder]="('jobboard.views.apply.sections.general.form.inputs.email' | transloco) + ' *'"
                  [autocomplete]="'off'"
                  maxlength="100"
                  id="email"
                  [readOnly]="loggedIn()"
                  />
                <label for="email">{{
                  ('jobboard.views.apply.sections.general.form.inputs.email' | transloco) +
                  '
                  *'
                }}</label>
                <div class="validation">
                  @if (email.hasError('required')) {
                    <p>{{ 'ct-library.validation.required' | transloco }}</p>
                  }
                  @if (email.hasError('pattern') || email.hasError('email')) {
                    <p>
                      {{ 'ct-library.validation.email' | transloco }}
                    </p>
                  }
                </div>
              </div>
            }
            @if (!missingData) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="(emailConfirm.invalid || applyForm.hasError('emailMismatch')) && applyFormSubmitAttempt"
                >
                <input
                  type="email"
                  class="form-control"
                  [formControl]="emailConfirm"
                  id="emailConfirm"
                  [placeholder]="('jobboard.views.apply.sections.general.form.inputs.email-repeat' | transloco) + ' *'"
                  [autocomplete]="'off'"
                  [readOnly]="loggedIn()"
                  />
                <label for="emailConfirm">{{
                  ('jobboard.views.apply.sections.general.form.inputs.email-repeat' | transloco) +
                  '
                  *'
                }}</label>
                <div class="validation">
                  @if (emailConfirm.hasError('required') && !applyForm.hasError('emailMismatch')) {
                    <p>
                      {{ 'ct-library.validation.required' | transloco }}
                    </p>
                  }
                  @if (
                    (emailConfirm.hasError('pattern') || emailConfirm.hasError('email')) &&
                    !applyForm.hasError('emailMismatch')
                    ) {
                    <p
                      >
                      {{ 'ct-library.validation.email' | transloco }}
                    </p>
                  }
                  @if (applyForm.hasError('emailMismatch')) {
                    <p>{{ 'ct-library.validation.email-match' | transloco }}</p>
                  }
                </div>
              </div>
            }
            @if (
              ((job$ | async)?.fields?.phone.show && !missingData) || initiative || (missingDataFields$ | async)?.phone
              ) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="phonePrefix.invalid && applyFormSubmitAttempt"
                >
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  class="form-control"
                  [formControl]="phonePrefix"
                  id="phonePrefix"
                  [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  >
                  @for (phonePrefixConstant of constantsService.phonePrefixConstants; track phonePrefixConstant) {
                    <ng-option
                      [value]="phonePrefixConstant.prefix"
                      >
                      {{ phonePrefixConstant.prefix }} {{ phonePrefixConstant.country | transloco }}
                    </ng-option>
                  }
                </ng-select>
                <label for="phonePrefix">{{
                  ('jobboard.views.apply.sections.general.form.inputs.phone-pre' | transloco) +
                  ((job$ | async)?.fields?.phone.required && !manualApplication ? ' *' : '')
                }}</label>
                <div class="validation">
                  @if (phonePrefix.hasError('required')) {
                    <p>{{ 'ct-library.validation.required' | transloco }}</p>
                  }
                </div>
              </div>
            }
            @if (
              ((job$ | async)?.fields?.phone.show && !missingData) || initiative || (missingDataFields$ | async)?.phone
              ) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="phone.invalid && applyFormSubmitAttempt"
                >
                <input
                  type="tel"
                  class="form-control"
                  [formControl]="phone"
                  [autocomplete]="'off'"
            [placeholder]="
              ('jobboard.views.apply.sections.general.form.inputs.phone' | transloco) +
              ((job$ | async)?.fields?.phone.required && !manualApplication ? ' *' : '')
            "
                  maxlength="30"
                  id="phone"
                  noSpaces
                  />
                <label for="phone">{{
                  ('jobboard.views.apply.sections.general.form.inputs.phone' | transloco) +
                  ((job$ | async)?.fields?.phone.required && !manualApplication ? ' *' : '')
                }}</label>
                <div class="validation">
                  @if (phone.hasError('required')) {
                    <p>{{ 'ct-library.validation.required' | transloco }}</p>
                  }
                  @if (phone.hasError('pattern') && !phone.hasError('required')) {
                    <p>
                      {{ 'ct-library.validation.pattern' | transloco }}
                    </p>
                  }
                </div>
              </div>
            }
            @if (
              ((job$ | async)?.fields.startDate.show && !missingData) ||
              initiative ||
              (missingDataFields$ | async)?.startDate
              ) {
              <div
                class="col-12 col-md-6 form-group"
                [class.invalid]="startDate.invalid && applyFormSubmitAttempt"
                >
                <app-date-input
                  [control]="startDate"
                  [datePickerConfig]="datePickerConfig"
                  [submitAttempt]="applyFormSubmitAttempt"
            [placeholder]="
              ('jobboard.views.apply.sections.general.form.inputs.start-date' | transloco) +
              ((job$ | async)?.fields.startDate.required && !manualApplication ? ' *' : '')
            "
                  >
                </app-date-input>
                <div class="validation">
                  <p>{{ 'ct-library.validation.required' | transloco }}</p>
                </div>
              </div>
            }
            @if (
              ((job$ | async)?.fields.salary.show && !missingData) || initiative || (missingDataFields$ | async)?.salary
              ) {
              <div
                class="col-12 col-md-6 form-group form-floating"
                [class.invalid]="salary.invalid && applyFormSubmitAttempt"
                >
                <ct-lib-salary-input
                  [currencyCode]="(job$ | async)?.currency ?? 'EUR'"
                  [control]="salary"
            [interval]="
              ((job$ | async)?.salaryInterval
                ? constantsService.getLabelByValue(
                    constantsService.salaryIntervalConstants,
                    (job$ | async).salaryInterval
                  )
                : constantsService.getLabelByValue(constantsService.salaryIntervalConstants, SalaryInterval.YEAR)
              ) | transloco
            "
            [placeholder]="
              ('jobboard.views.apply.sections.general.form.inputs.salary' | transloco) +
              ' (' +
              (((job$ | async)?.salaryInterval
                ? constantsService.getLabelByValue(
                    constantsService.salaryIntervalConstants,
                    (job$ | async).salaryInterval
                  )
                : constantsService.getLabelByValue(constantsService.salaryIntervalConstants, SalaryInterval.YEAR)
              ) | transloco) +
              ')' +
              ((job$ | async)?.fields.salary.required && !manualApplication ? ' *' : '')
            "
                  >
                </ct-lib-salary-input>
                <div class="validation">
                  @if (salary.hasError('required')) {
                    <p>{{ 'ct-library.validation.required' | transloco }}</p>
                  }
                  @if (salary.hasError('max')) {
                    <p>{{ 'ct-library.validation.pattern' | transloco }}</p>
                  }
                </div>
              </div>
            }
            @if (
              ((job$ | async)?.workLocations.length > 1 && !initiative)
              &&
              ( (job$ | async)?.workingModel === WorkingModel.HYBRID || (job$ | async)?.workingModel === WorkingModel.ON_SITE ) &&
              !missingData
              ) {
              <div class="col-12 form-group form-floating">
                <ng-select
                  [items]="(job$ | async)?.workLocations"
                  [multiple]="true"
                  [selectableGroup]="true"
                  [closeOnSelect]="false"
                  [searchable]="false"
                  [formControl]="workLocations"
                  [clearable]="true"
                  [placeholder]=" 'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  id="workLocations"
                  bindValue="id"
                  class="form-control facilitySelect"
                  #workLocationsForm
                  >
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input
                      id="item-{{ index }}"
                      type="checkbox"
                      [ngModel]="item$.selected"
                      [ngModelOptions]="{standalone: true}"
                      />
                    {{ item.city }} ({{ item.postalCode }})
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    <ct-lib-tag class="mb-1 ms-1" [accentColor]="colorService.accent">
                      {{ item.city }} ({{ item.postalCode }})
                    </ct-lib-tag>
                  </ng-template>
                </ng-select>
                <label for="workLocations">{{
                  'jobboard.views.apply.sections.general.form.inputs.facility' | transloco
                }}</label>
              </div>
            }
          </div>
        </div>
      }
      @if ((job$ | async)?.fields.socialMedia?.show && urls.controls.length > 0) {
        <div class="view-section">
          <h4>{{ 'jobboard.views.apply.sections.social-media.title' | transloco }}</h4>
          @for (control of urls.controls; track control; let i = $index) {
            <div class="row social-media">
              <img
                [src]="'/assets/img/jobmarket_logos/' + getPageForIndex(i) + '.png'"
                [alt]="'Logo - ' + getPageForIndex(i)"
                loading="lazy"
                class="icon"
                />
              <div
                class="col-12 form-group form-floating social-media-form"
                [class.invalid]="control.invalid && applyFormSubmitAttempt"
                >
                <input
                  type="text"
                  class="form-control"
                  [formControl]="control"
                  [id]="'url' + i"
                  [placeholder]="'jobboard.views.apply.sections.social-media.placeholders.' + getPageForIndex(i) | transloco"
                  [autocomplete]="'off'"
                  />
                <label class="page-label" [for]="'url' + i">{{
                  'jobboard.views.apply.sections.social-media.placeholders.' + getPageForIndex(i) | transloco
                }}</label>
                <div class="validation">
                  @if (control.hasError('start')) {
                    <p>
                      {{ 'jobboard.views.apply.sections.social-media.url-not-valid' | transloco }}
                    </p>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (!initiative && !manualApplication && (job$ | async)?.questions.length > 0) {
        <div class="view-section">
          <h4>{{ 'jobboard.views.apply.sections.questions.title' | transloco }}</h4>
          @for (control of questions.controls; track control; let i = $index;) {
            <div class="question">
              <p class="text-start">{{ (job$ | async)?.questions[i].question }}</p>
              <div class="form-group form-floating" [class.invalid]="control.invalid && applyFormSubmitAttempt">
                <textarea
                  class="form-control mt-2"
                  [formControl]="control"
                  autosize
                  [maxRows]="5"
            [placeholder]="
              ('jobboard.views.apply.sections.questions.form.answer.placeholder' | transloco) +
              ((job$ | async)?.questions[i].required && !manualApplication ? ' *' : '')
            "
                  [id]="'question' + i"
                ></textarea>
                <label [for]="'question' + i">{{
                  ('jobboard.views.apply.sections.questions.form.answer.placeholder' | transloco) +
                  ((job$ | async)?.questions[i].required && !manualApplication ? ' *' : '')
                }}</label>
              </div>
            </div>
          }
        </div>
      }
      @if ((job$ | async)?.languages.length + (job$ | async)?.skills.length > 0 && !manualApplication) {
        <div
          class="view-section"
          >
          @if ((job$ | async)?.languages.length > 0) {
            <div>
              <h4>{{ 'jobboard.views.apply.sections.skills.languages.title' | transloco }}</h4>
              @for (control of languages.controls; track control; let i = $index) {
                <div class="row d-flex align-items-center">
                  <div class="col-12 col-md-6">
                    <p class="text-start">
                      {{ constantsService.getLanguageName(constantsService.getLanguageByCode((job$ | async).languages[i])) }}
                    </p>
                  </div>
                  <div
                    class="col-12 col-md-6 form-group form-floating"
                    [class.invalid]="control.invalid && applyFormSubmitAttempt"
                    >
                    <ng-select
                      [searchable]="false"
                      class="form-control"
                      [formControl]="control"
                      (change)="selectLanguageLevel($event, i)"
                      [id]="'language' + i"
                      [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                      >
                      @for (
                        languageLevelConstant of languageLevelLabels
                        ; track
                        languageLevelConstant) {
                        <ng-option
                          [value]="languageLevelConstant.value"
                          >
                          {{ languageLevelConstant.label | transloco }}
                        </ng-option>
                      }
                    </ng-select>
                    <label [for]="'language' + i">{{
                      ('jobboard.views.apply.sections.skills.languages.form.level.placeholder' | transloco) + ' *'
                    }}</label>
                  </div>
                </div>
              }
            </div>
          }
          @if ((job$ | async)?.skills.length > 0) {
            <div>
              <h4>{{ 'jobboard.views.apply.sections.skills.skills.title' | transloco }}</h4>
              @for (control of skills.controls; track control; let i = $index ) {
                <div class="row d-flex align-items-center">
                  <div class="col-12 col-md-6">
                    <p class="text-start">{{ (job$ | async)?.skills[i].name }}</p>
                  </div>
                  <div
                    class="col-12 col-md-6 form-group form-floating"
                    [class.invalid]="control.invalid && applyFormSubmitAttempt"
                    >
                    @if ((job$ | async)?.skills[i].level) {
                      <ng-select
                        [searchable]="false"
                        class="form-control"
                        [class.skill-select]="(job$ | async)?.skills[i].skillType !== SkillType.KO"
                        [formControl]="control"
                        (change)="selectSkillLevel($event, i)"
                        [id]="'skill' + i"
                        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                        #level
                        >
                        @for (skillLevelConstant of skillLevelLabels; track skillLevelConstant) {
                          <ng-option [value]="skillLevelConstant.value">
                            {{ skillLevelConstant.label | transloco }}
                          </ng-option>
                          } @if ((job$ | async)?.skills[i].skillType !== SkillType.KO) {
                          <ng-option value="comparable">
                            {{ 'jobboard.views.apply.sections.skills.skills.form.comparable-skill' | transloco }}
                          </ng-option>
                        }
                      </ng-select>
                    } @else {
                      <ng-select
                        [searchable]="false"
                        class="form-control"
                        [class.skill-select]="(job$ | async)?.skills[i].skillType !== SkillType.KO"
                        [formControl]="control"
                        (change)="selectSkillLevel($event, i)"
                        [id]="'skill' + i"
                        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                        #level
                        >
                        @for (skillLevelExistingConstant of skillExistingLabels; track skillLevelExistingConstant) {
                          <ng-option [value]="skillLevelExistingConstant.value">
                            {{ skillLevelExistingConstant.label | transloco }}
                          </ng-option>
                          } @if ((job$ | async)?.skills[i].skillType !== SkillType.KO) {
                          <ng-option value="comparable-0">
                            {{ 'jobboard.views.apply.sections.skills.skills.form.comparable-skill' | transloco }}
                          </ng-option>
                        }
                      </ng-select>
                    }
                    <label [for]="'skill' + i">{{
                      ('jobboard.views.apply.sections.skills.skills.form.level.placeholder' | transloco) + ' *'
                    }}</label>
                  </div>
                </div>
                @if (control.value === 'comparable') {
                  <div class="row" @collapse>
                    <div
                      class="col-12 col-md-6 offset-md-6 form-group form-floating"
                      [class.invalid]="comparableSkills.controls[i].invalid && applyFormSubmitAttempt"
                      >
                      @if ((job$ | async)?.skills[i].level) {
                        <ng-select
                          [searchable]="false"
                          class="form-control"
                          [formControl]="comparableSkills.controls[i]"
                          (change)="selectSkillLevel($event, i)"
                          [id]="'skill' + i"
                          [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                          >
                          @for (skillLevelConstant of skillLevelLabels; track skillLevelConstant) {
                            <ng-option [value]="'comparable-' + skillLevelConstant.value">
                              {{ skillLevelConstant.label | transloco }}
                            </ng-option>
                          }
                        </ng-select>
                      } @else {
                        <ng-select
                          [searchable]="false"
                          class="form-control"
                          [formControl]="comparableSkills.controls[i]"
                          (change)="selectSkillLevel($event, i)"
                          [id]="'skill' + i"
                          [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                          >
                          @for (skillLevelExistingConstant of skillExistingLabels; track skillLevelExistingConstant) {
                            <ng-option [value]="'comparable-' + skillLevelExistingConstant.value">
                              {{ skillLevelExistingConstant.label | transloco }}
                            </ng-option>
                          }
                        </ng-select>
                      }
                      <label [for]="'skill' + i">{{
                        ('jobboard.views.apply.sections.skills.skills.form.level.comparable-placeholder' | transloco) + ' *'
                      }}</label>
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
      @if (
        ((job$ | async)?.isaEnabled && !manualApplication && !missingData) ||
        (missingDataFields$ | async)?.isa ||
        (initiative && (companyInformation$ | async)?.ISA)
        ) {
        <div
          class="view-section"
          >
          <h4>{{ 'jobboard.views.apply.sections.personality.title' | transloco }} *</h4>
          <ct-lib-inline-info [infoIconAccentColor]="colorService.accent">
            <p [innerHTML]="'jobboard.views.apply.sections.personality.info' | transloco"></p>
          </ct-lib-inline-info>
          @if (!skillTest.completed) {
            <h6 class="text-center">{{ 'ct-library.isa.questions.main' | transloco }}</h6>
          }
          @if (skillTest.completed) {
            <h6 class="text-center">{{ 'ct-library.isa.done' | transloco }}</h6>
          }
          <app-skill-test [control]="isa" [submitAttempt]="applyFormSubmitAttempt" #skillTest></app-skill-test>
        </div>
      }
      @if ((!missingData && fileInputCount() > 0) || missingDataFieldsDocuments()) {
        <div
          class="view-section documents"
          >
          <h4>{{ 'jobboard.views.apply.sections.documents.title' | transloco }}</h4>
          @if (
            (job$ | async)?.fields.image.show ||
            (missingDataFields$ | async)?.others ||
            (missingDataFields$ | async)?.image
            ) {
            <div
              class="row picture-edit d-flex justify-content-center"
              >
              <p>{{ 'jobboard.views.apply.sections.documents.form.image.placeholder' | transloco }}</p>
              <ct-lib-image-editor
                [control]="image"
                [ratio]="2 / 3"
                [submitAttempt]="applyFormSubmitAttempt"
                [accept]="'image/png, image/jpeg'"
                class="mt-2"
                >
              </ct-lib-image-editor>
            </div>
          }
          <div class="row">
            @if (
              ((job$ | async)?.fields.cv.show && !missingData) ||
              initiative ||
              manualApplication ||
              (missingDataFields$ | async)?.cv
              ) {
              <div
                [class]="fileInputCols()"
                >
                <ct-lib-file-input
                  (change)="onFileUpload($event)"
                  [control]="cv"
            [label]="
              ('jobboard.views.apply.sections.documents.form.cv.placeholder' | transloco) +
              ((job$ | async)?.fields.cv.required && !manualApplication ? ' *' : '')
            "
                  [accept]="fileTypes"
                  [showAcceptLabel]="false"
                  [multiple]="false"
                  [submitAttempt]="applyFormSubmitAttempt"
                  [accentColor]="colorService.accent"
                  >
                </ct-lib-file-input>
              </div>
            }
            @if (
              ((job$ | async)?.fields.coverLetter.show && !missingData) ||
              initiative ||
              manualApplication ||
              (missingDataFields$ | async)?.coverLetter
              ) {
              <div
                [class]="fileInputCols()"
                >
                <ct-lib-file-input
                  [control]="coverLetter"
            [label]="
              ('jobboard.views.apply.sections.documents.form.cover-letter.placeholder' | transloco) +
              ((job$ | async)?.fields.coverLetter.required && !manualApplication ? ' *' : '')
            "
                  [accept]="fileTypes"
                  [showAcceptLabel]="false"
                  [multiple]="false"
                  [submitAttempt]="applyFormSubmitAttempt"
                  [accentColor]="colorService.accent"
                  >
                </ct-lib-file-input>
              </div>
            }
            @if (
              ((job$ | async)?.fields.certificates.show && !missingData) ||
              initiative ||
              manualApplication ||
              (missingDataFields$ | async)?.certificates
              ) {
              <div
                [class]="fileInputCols()"
                >
                <ct-lib-file-input
                  [control]="certificates"
            [label]="
              ('jobboard.views.apply.sections.documents.form.certificates.placeholder' | transloco) +
              ((job$ | async)?.fields.certificates.required && !manualApplication ? ' *' : '')
            "
                  [accept]="fileTypes"
                  [showAcceptLabel]="false"
                  [submitAttempt]="applyFormSubmitAttempt"
                  [accentColor]="colorService.accent"
                  >
                </ct-lib-file-input>
              </div>
            }
            @if (
              ((job$ | async)?.fields.others.show && !missingData) ||
              initiative ||
              manualApplication ||
              (missingDataFields$ | async)?.others
              ) {
              <div
                [class]="fileInputCols()"
                >
                <ct-lib-file-input
                  [control]="others"
                  [label]="'jobboard.views.apply.sections.documents.form.others.placeholder' | transloco"
                  [accept]="fileTypes"
                  [showAcceptLabel]="false"
                  [submitAttempt]="applyFormSubmitAttempt"
                  [accentColor]="colorService.accent"
                  >
                </ct-lib-file-input>
              </div>
            }
          </div>
          <!--<button *ngIf="(manualApplication || manualInitiative || missingData) && cv.value.length !== 0"
          class="ct-btn ct-btn-themed-solid mx-auto mt-3"
          [disabled]="sendingCv" (click)="onApplyCvPrefill()">
          {{'jobboard.views.apply.sections.documents.form.cv.prefill' | transloco}}
          <span class="spinner-border text-secondary" role="status" *ngIf="sendingCv"></span>
        </button>-->
      </div>
    }
    <div class="view-section">
      <h4>{{ 'jobboard.views.apply.sections.finish.title' | transloco }}</h4>
      <div class="form-group terms-accept">
        <input
          type="checkbox"
          id="terms-accept-input"
          [(ngModel)]="termsChecked"
          [ngModelOptions]="{standalone: true}"
          (change)="captcha?.start()"
          />
        <label for="terms-accept-input">
          {{ 'jobboard.views.apply.sections.finish.agb-1' | transloco }}
          <a href="https://catch.hr/tos-applicants" target="_blank">{{
            'jobboard.views.apply.sections.finish.agb-2' | transloco
          }}</a>
          {{ 'jobboard.views.apply.sections.finish.agb-3' | transloco }}
          @if(privacyCheckboxExpanded) {
            <p [innerHTML]="'jobboard.views.apply.sections.finish.agb-4' | transloco" @collapseZoom></p>
          }
          <a (click)="$event.preventDefault(); privacyCheckboxExpanded = !privacyCheckboxExpanded">{{(privacyCheckboxExpanded ? 'jobboard.views.apply.sections.finish.checkboxes.show-less' : 'jobboard.views.apply.sections.finish.checkboxes.show-more') | transloco}}</a>
        </label>
        <input
          type="checkbox"
          id="terms-accept-input2"
          [(ngModel)]="termsChecked2"
          [ngModelOptions]="{standalone: true}"
          />
        <label for="terms-accept-input2">
          {{ 'jobboard.views.apply.sections.finish.agb-2-1' | transloco }}
        </label>
      </div>
      <div class="captcha-wrapper">
        @if (!missingData) {
          <ct-lib-friendly-captcha
            #friendlyCaptcha
            [class.invalid]="applyFormSubmitAttempt && captchaCode.invalid && !sending"
            [control]="captchaCode"
            >
          </ct-lib-friendly-captcha>
        }
      </div>
      @if (normalApplication || (initiative && !manualInitiative)) {
        <button
          class="ct-btn ct-btn-themed-solid mx-auto submit-btn"
          [disabled]="!termsChecked || sending || captchaCode.invalid"
          (click)="onApplyFormSubmit()"
          >
          {{ 'jobboard.views.apply.sections.finish.apply-button' | transloco }}
          @if (sending) {
            <span class="spinner-border text-secondary" role="status"></span>
          }
        </button>
      }
      @if (manualApplication || manualInitiative || missingData) {
        <button
          class="ct-btn ct-btn-themed-solid mx-auto submit-btn"
          [disabled]="!termsChecked || sending || captchaCode.invalid"
          (click)="onApplyFormSubmit()"
          >
          {{ 'jobboard.views.apply.sections.finish.apply-button-manual' | transloco }}
          @if (sending) {
            <span class="spinner-border text-secondary" role="status"></span>
          }
        </button>
      }
    </div>
  </form>
</div>

<ct-lib-confirm-modal #imageModal>
  <image-cropper #imageCropper [maintainAspectRatio]="true" [aspectRatio]="1 / 1" format="png"> </image-cropper>
</ct-lib-confirm-modal>

<ct-lib-confirm-modal #navigationConfirmModal>
  <p>{{ 'jobboard.views.apply.cancel-modal.text' | transloco }}</p>
</ct-lib-confirm-modal>

<app-privacy-modal #privacyModal></app-privacy-modal>
} @else {
  <div class="view-content success">
    <div>
      <app-animated-check [color]="colorService.accent"></app-animated-check>
      @if(normalApplication || (initiative && !manualApplication)) {
        <p>{{ 'jobboard.views.apply.sections.finish.done' | transloco }}</p>
      } @else if (manualApplication) {
        <p>{{ 'jobboard.views.apply.sections.finish.done-manual' | transloco }}</p>
      } @else if(missingData) {
        <p>{{ 'jobboard.views.apply.sections.finish.done-missing-data' | transloco }}</p>
      }
      @if (submittedWhileLoggedOut) {
        <p class="register-cta">{{ 'jobboard.views.apply.sections.finish.register-cta' | transloco }}</p>
        <button
          type="button"
          class="ct-btn ct-btn-themed-solid"
          (click)="openRegister()"
        >
          {{ 'jobboard.views.apply.sections.finish.register-cta-button' | transloco }}
        </button>
      }
    </div>
  </div>
  } } @else {
  <div class="view-content job-closed">
    <div>
      <app-animated-cross></app-animated-cross>
      <p>{{ 'jobboard.views.apply.sections.finish.job-closed' | transloco }}</p>
      <a [routerLink]="['/companies', route.snapshot.params['companyId']]">
        {{ 'jobboard.views.apply.sections.finish.job-closed-link' | transloco }}
      </a>
    </div>
  </div>
}
